(function () {
  "use strict";

  const MEERA_API = "https://meera-v1.onrender.com";

  const SESSION_KEY = "meera_session_id";

  function getSessionId() {
    let sessionId = localStorage.getItem(SESSION_KEY);

    if (!sessionId) {
      sessionId =
        "shopify-" +
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).substring(2, 10);

      localStorage.setItem(SESSION_KEY, sessionId);
    }

    return sessionId;
  }

  function escapeHtml(value) {
    const div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function formatPrice(price) {
    if (price == null || price === "") {
      return "";
    }

    const number = Number(price);

    if (Number.isNaN(number)) {
      return String(price);
    }

    return "₹" + number.toLocaleString("en-IN");
  }

  function createWidget() {
    if (document.getElementById("meera-widget")) {
      return;
    }

    const root = document.createElement("div");
    root.id = "meera-widget";

    root.innerHTML = `
      <style>
        #meera-widget {
          font-family: Arial, Helvetica, sans-serif;
          position: fixed;
          right: 18px;
          bottom: 18px;
          z-index: 999999;
          display: flex;
          align-items: center;
        }

        #meera-widget-button {
            width: 82px;
            height: auto;
            min-height: 100px;
            padding: 0;
            border: none;
            background: transparent;
            color: #222;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 5px;
            box-shadow: none;
        }

        .meera-button-icon {
            width: 72px;
            height: 72px;
            border-radius: 50%;
            object-fit: cover;
            display: block;
            border: 2px solid #d8c28f;
            box-shadow: 0 4px 12px rgba(0,0,0,0.18);
            }

            .meera-button-label {
            display: inline-block;
            background: #d8c28f;
            color: #222;
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 600;
            line-height: 1.2;
            white-space: nowrap;
        }

        #meera-widget-panel {
          display: none;
          position: absolute;
          right: 0;
          bottom: 72px;
          width: 380px;
          max-width: calc(100vw - 32px);
          height: 620px;
          max-height: calc(100vh - 110px);
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 8px 35px rgba(0,0,0,0.2);
        }

        #meera-widget-header {
         padding: 16px;
         background: #d8c28f;
         color: #222;
         display: flex;
         align-items: center;
         justify-content: space-between;
        }

        .meera-header-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .meera-header-icon {
         width: 36px;
         height: 36px;
         border-radius: 50%;
         object-fit: cover;
        }

        #meera-widget-header strong {
          font-size: 16px;
        }

        #meera-widget-close {
          background: transparent;
          border: none;
          color: #fff;
          cursor: pointer;
          font-size: 20px;
        }

        #meera-widget-messages {
          height: calc(100% - 125px);
          overflow-y: auto;
          padding: 14px;
          background: #fafafa;
        }

        .meera-message {
          margin-bottom: 12px;
          line-height: 1.45;
          font-size: 14px;
        }

        .meera-user {
          text-align: right;
        }

        .meera-user span,
        .meera-assistant span {
          display: inline-block;
          padding: 10px 12px;
          border-radius: 12px;
          max-width: 85%;
        }

        .meera-user span {
          background: #222;
          color: #fff;
        }

        .meera-assistant span {
          background: #fff;
          border: 1px solid #ddd;
          color: #222;
        }

        .meera-products {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 10px;
        }

        .meera-product {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 10px;
          overflow: hidden;
        }

        .meera-product img {
          width: 100%;
          height: 190px;
          object-fit: cover;
          display: block;
        }

        .meera-product-body {
          padding: 10px;
        }

        .meera-product-name {
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 5px;
        }

        .meera-product-price {
          font-size: 14px;
          margin-bottom: 8px;
        }

        .meera-product-link {
          display: inline-block;
          text-decoration: none;
          font-size: 13px;
          color: #222;
          border-bottom: 1px solid #222;
        }

        #meera-widget-input-area {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 68px;
          display: flex;
          gap: 8px;
          padding: 10px;
          background: #fff;
          border-top: 1px solid #ddd;
        }

        #meera-widget-input {
          flex: 1;
          min-width: 0;
          border: 1px solid #ccc;
          border-radius: 22px;
          padding: 0 14px;
          font-size: 14px;
          outline: none;
        }

        #meera-widget-send {
          width: 70px;
          border: none;
          border-radius: 22px;
          background: #222;
          color: #fff;
          cursor: pointer;
        }

        #meera-widget-send:disabled {
          opacity: 0.5;
          cursor: default;
        }

        .meera-loading {
          color: #777;
          font-style: italic;
        }

        @media (max-width: 600px) {
          #meera-widget {
            right: 12px;
            bottom: 12px;
          }

          #meera-widget-panel {
            width: calc(100vw - 32px);
            height: 72vh;
            max-height: 620px;
            bottom: 82px;
            right: 0;
          }
        }
      </style>

      <button id="meera-widget-button" aria-label="Ask Meera">
        <img
            src="${window.MEERA_LOGO_URL}"
            alt="Meera"
            class="meera-button-icon"
        />
        <span class="meera-button-label">Ask Meera</span>
      </button>

      <div id="meera-widget-panel">
        <div id="meera-widget-header">
          <div class="meera-header-left">
            <img
            src="${window.MEERA_LOGO_URL}"
            alt="Meera"
            class="meera-header-icon"
            />
            <strong>Meera</strong>
        </div>

        <button id="meera-widget-close" aria-label="Close">×</button>
      </div>

        <div id="meera-widget-messages"></div>

        <div id="meera-widget-input-area">
          <input
            id="meera-widget-input"
            type="text"
            placeholder="Ask Meera..."
            autocomplete="off"
          />
          <button id="meera-widget-send">Send</button>
        </div>
      </div>
    `;

    document.body.appendChild(root);

    const button = document.getElementById("meera-widget-button");
    const panel = document.getElementById("meera-widget-panel");
    const close = document.getElementById("meera-widget-close");
    const input = document.getElementById("meera-widget-input");
    const send = document.getElementById("meera-widget-send");
    const messages = document.getElementById("meera-widget-messages");

    function addMessage(text, type) {
      const message = document.createElement("div");

      message.className =
        "meera-message " +
        (type === "user" ? "meera-user" : "meera-assistant");

      message.innerHTML =
        "<span>" +
        escapeHtml(text).replace(/\n/g, "<br>") +
        "</span>";

      messages.appendChild(message);
      messages.scrollTop = messages.scrollHeight;

      return message;
    }

    function addProducts(products) {
      if (!Array.isArray(products) || products.length === 0) {
        return;
      }

      const wrapper = document.createElement("div");
      wrapper.className = "meera-products";

      products.forEach(function (product) {
        if (!product) {
          return;
        }

        const name =
          product["Product name"] ||
          product["Title"] ||
          "Product";

        const price =
          product["Price"] ??
          product["Variant Price"] ??
          product["price"];

        const image =
          product["Image"] ||
          product["Image URL"] ||
          product["image"];

        const url =
          product["URL"] ||
          product["url"];

        const card = document.createElement("div");
        card.className = "meera-product";

        let html = "";

        if (image) {
          html += `
            <img
              src="${escapeHtml(image)}"
              alt="${escapeHtml(name)}"
              loading="lazy"
            />
          `;
        }

        html += `
          <div class="meera-product-body">
            <div class="meera-product-name">
              ${escapeHtml(name)}
            </div>

            <div class="meera-product-price">
              ${escapeHtml(formatPrice(price))}
            </div>
        `;

        if (url) {
          html += `
            <a
              class="meera-product-link"
              href="${escapeHtml(url)}"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Product
            </a>
          `;
        }

        html += `
          </div>
        `;

        card.innerHTML = html;
        wrapper.appendChild(card);
      });

      messages.appendChild(wrapper);
      messages.scrollTop = messages.scrollHeight;
    }

    async function sendMessage() {
      const message = input.value.trim();

      if (!message || send.disabled) {
        return;
      }

      addMessage(message, "user");

      input.value = "";
      send.disabled = true;
      input.disabled = true;

      const loading = addMessage("Meera is thinking...", "assistant");
      loading.querySelector("span").classList.add("meera-loading");

      try {
        const response = await fetch(MEERA_API + "/chat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            session_id: getSessionId(),
            message: message
          })
        });

        if (!response.ok) {
          throw new Error("API request failed: " + response.status);
        }

        const data = await response.json();

        loading.remove();

        if (data.message) {
          addMessage(data.message, "assistant");
        }

        if (Array.isArray(data.products)) {
          addProducts(data.products);
        }

        if (
          (!data.message || data.message.trim() === "") &&
          (!Array.isArray(data.products) || data.products.length === 0)
        ) {
          addMessage(
            "I couldn't find a suitable response right now. Please try another request.",
            "assistant"
          );
        }
      } catch (error) {
        console.error("Meera widget error:", error);

        loading.remove();

        addMessage(
          "I'm having trouble connecting right now. Please try again.",
          "assistant"
        );
      } finally {
        send.disabled = false;
        input.disabled = false;
        input.focus();
      }
    }

    button.addEventListener("click", function () {
      panel.style.display = "block";
      input.focus();
    });

    close.addEventListener("click", function () {
      panel.style.display = "none";
    });

    send.addEventListener("click", sendMessage);

    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        sendMessage();
      }
    });

    addMessage(
      "Hi, I'm Meera. What are you looking for today?",
      "assistant"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createWidget);
  } else {
    createWidget();
  }
})();